import { render, staticRenderFns } from "./mine-address-page.vue?vue&type=template&id=3c3a19c4&scoped=true"
import script from "./mine-address-page.vue?vue&type=script&lang=js"
export * from "./mine-address-page.vue?vue&type=script&lang=js"
import style0 from "./mine-address-page.vue?vue&type=style&index=0&id=3c3a19c4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3a19c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/快电商/preview-qcommerce-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c3a19c4')) {
      api.createRecord('3c3a19c4', component.options)
    } else {
      api.reload('3c3a19c4', component.options)
    }
    module.hot.accept("./mine-address-page.vue?vue&type=template&id=3c3a19c4&scoped=true", function () {
      api.rerender('3c3a19c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/h5/mine-address-page.vue"
export default component.exports